// extracted by mini-css-extract-plugin
export var container = "_ei-0";
export var icon = "_ei-1";
export var text = "_ei-2";